'use strict';


function parseSingle(input) {
    var parts = input.split('&');
    var part;
    var record = {};

    for (var i = 0; i < parts.length; i++) {
        part = parts[i].split('=');
        record[part[0]] = part[1];
    }

    return record;
}

const formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS'
});

function setMaxValue() {
    var priceRanges = $('[data-prices]');
    var priceInputMin = $('[data-min-input-price]');
    var priceSlideMin = $('[data-range-min-price]');
    var priceInputMax = $('[data-max-input-price]');
    var priceSlideMax = $('[data-range-max-price]');
    var currentUrl = window.location.href;
    var maxPrice = parseInt(priceRanges.text().split('-')[1]);
    var minPrice = parseInt(priceRanges.text().split('-')[0]);
    var selectedMinPrice = minPrice;
    var selectedMaxPrice = maxPrice;

    if (currentUrl.includes('&pmin')) {
        var urlParsed = parseSingle(currentUrl);
        var priceBtnUrl = currentUrl.split('&pmin')[0];
        $('.prices-pill').attr('data-href', priceBtnUrl);
        $('.prices-close-pill').attr('data-href', priceBtnUrl);
        $('#eraseFilters').removeClass('d-none');
        selectedMinPrice = parseInt(urlParsed.pmin);
        selectedMaxPrice = parseInt(urlParsed.pmax);
    }

    priceInputMin.attr('max', maxPrice)
        .attr('min', 0)
        .attr('value', selectedMinPrice);
    priceSlideMin.attr('max', maxPrice)
        .attr('min', 0)
        .attr('min', selectedMinPrice);
    priceInputMax.attr('max', maxPrice)
        .attr('min', 0)
        .attr('value', selectedMaxPrice);
    priceSlideMax.attr('max', maxPrice)
        .attr('min', 0)
        .attr('value', selectedMaxPrice);

    priceSliderFunctionality();
}

function displayActualPriceFilter(min, max, target) {
    var priceRanges = $('[data-prices]');
    var selectedFilter = priceRanges.siblings('.fa');
    var selectedMinPrice = parseInt(min.split('$')[1].toLocaleString().replaceAll('.', ''));
    var selectedMaxPrice = parseInt(max.split('$')[1].toLocaleString().replaceAll('.', ''));

    var priceInputMin = $('[data-min-input-price]');
    var priceSlideMin = $('[data-range-min-price]');
    var priceInputMax = $('[data-max-input-price]');
    var priceSlideMax = $('[data-range-max-price]');

    var maxPrice = parseInt(priceRanges.text().split('-')[1]);
    var minPrice = parseInt(priceRanges.text().split('-')[0]);
    if (target.hasClass('reset') || target.hasClass('prices-close-pill')) {
        selectedMaxPrice = maxPrice;
        selectedMinPrice = minPrice;
    }

    if (selectedMaxPrice > maxPrice) {
        selectedMaxPrice = maxPrice;
    }

    priceInputMin.attr('min', 0)
        .attr('max', maxPrice)
        .attr('value', selectedMinPrice);

    priceSlideMin.attr('min', 0)
        .attr('max', maxPrice)
        .attr('value', selectedMinPrice);

    priceInputMax.attr('min', 0)
        .attr('max', maxPrice)
        .attr('value', selectedMaxPrice);

    priceSlideMax.attr('min', 0)
        .attr('max', maxPrice)
        .attr('value', selectedMaxPrice);

    if (selectedMaxPrice > maxPrice) { selectedMaxPrice = maxPrice; }

    priceSliderFunctionality();

    var resetUrl = $('[data-url-prices]').text().split('&pmin')[0];
    if (selectedMaxPrice != maxPrice || selectedMinPrice != 0) {
        selectedFilter.removeClass('fa-square-o').addClass('fa-check-square');
        $('.prices-pill').attr('data-href', resetUrl);
        $('.prices-close-pill').attr('data-href', resetUrl);
        $('#eraseFilters').removeClass('d-none');
    } else if (selectedFilter.hasClass('fa-check-square')) {
        selectedFilter.removeClass('fa-check-square').addClass('fa-square-o');
        $('.pills-container').remove($('.prices-pill'));
        $('#eraseFilters').addClass('d-none');
    } else if (target.hasClass('reset')) {
        selectedFilter.removeClass('fa-check-square').addClass('fa-square-o');
        $('.pills-container').remove($('.prices-pill'));
        $('#eraseFilters').addClass('d-none');
    }
}

function setSliderColor(progress, range, minRange, maxRange, inputValue) {
    progress.css('left', (minRange / range[0].max) * 100 + '%');
    progress.css('right', 100 - (maxRange / range[1].max) * 100 + '%');
    var formattedMinPrice = formatter.format(minRange).replace(',00', '');
    var formattedMaxPrice = formatter.format(maxRange).replace(',00', '');
    inputValue[0].value = formattedMinPrice;
    inputValue[1].value = formattedMaxPrice;
}

function priceSliderFunctionality() {
    const range = $('.range-slider .rangeBar');
    const progress = $('.range-slider .progress');
    const inputValue = $('.numberVal input');
    const maxRangeVisibility = $('.refinement-bar .range-slider .range-max');
    const minRangeVisibility = $('.refinement-bar .range-slider .range-min');

    if (range.length > 0) {
        let gap = 1000;
        let minRange = parseInt(range[0].value);
        let maxRange = parseInt(range[1].value);

        setSliderColor(progress, range, minRange, maxRange, inputValue);
        setPriceSearchUrl();

        range.each(function () {
            $(this).on('input', function (e) {
                minRange = parseInt(range[0].value);
                maxRange = parseInt(range[1].value);

                if (maxRange - minRange < gap) {
                    if ($(this).hasClass('range-min')) {
                        range[0].value = maxRange - gap;
                    } else {
                        range[1].value = minRange + gap;
                    }
                } else {
                    setSliderColor(progress, range, minRange, maxRange, inputValue);
                    setPriceSearchUrl();
                }
            });
        });

        $(maxRangeVisibility, minRangeVisibility).on('touchstart click', function () {
            maxRangeVisibility.css('z-index', '10');
            minRangeVisibility.css('z-index', '9');
        });
    }
}

function setPriceSearchUrl() {
    var buttonSearchPrices = $('[data-search-prices]');
    var priceInputMin = $('[data-min-input-price]').val();
    priceInputMin = priceInputMin.split('$')[1].toLocaleString().replaceAll('.', '');
    priceInputMin = parseInt(priceInputMin, 10);

    var priceInputMax = $('[data-max-input-price]').val();
    priceInputMax = priceInputMax.split('$')[1].toLocaleString().replaceAll('.', '');
    priceInputMax = parseInt(priceInputMax, 10) + 1;


    var minPrice = Number(priceInputMin);
    var maxPrice = Number(priceInputMax);

    var priceUrl = $('[data-url-prices]').text().split('pmin')[0] + 'pmin=' + minPrice + '&pmax=' + maxPrice;

    buttonSearchPrices.attr('data-href', priceUrl);
    buttonSearchPrices.attr('data-min-price', priceInputMin);
    buttonSearchPrices.attr('data-max-price', priceInputMax);
}

module.exports = {
    displayActualPriceFilter: displayActualPriceFilter,
    setMaxValue: setMaxValue
};
